var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34352 3.44231C7.34352 4.65309 6.362 5.63462 5.15122 5.63462C3.94044 5.63462 2.95891 4.65309 2.95891 3.44231C2.95891 2.23153 3.94044 1.25 5.15122 1.25C6.362 1.25 7.34352 2.23153 7.34352 3.44231Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15122 10.75C7.32287 10.75 8.57405 10.1898 9.15445 9.82929C9.42603 9.66058 9.55989 9.34994 9.53227 9.02814C9.49455 8.58865 9.34099 8.1497 9.18464 7.80153C8.97936 7.34439 8.50415 7.09615 8.00303 7.09615H2.2994C1.79828 7.09615 1.32308 7.34439 1.11779 7.80153C0.961441 8.1497 0.807881 8.58864 0.77016 9.02814C0.742539 9.34994 0.876399 9.66058 1.14799 9.82929C1.72839 10.1898 2.97956 10.75 5.15122 10.75Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2ee69285d8e2e14ea57393fd341a8801.svg";
export { ForwardRef as ReactComponent };